import { HOME_SPECIAL_CARS, HOME_COUNTERS, HOME_NEWS } from '../constants/actionTypes';

/* Common action creators */

const setHomeSpecialCars = cars => ({
  type: HOME_SPECIAL_CARS.SET,
  payload: cars,
});

const setHomeCounters = cars => ({
  type: HOME_COUNTERS.SET,
  payload: cars,
});

const setHomeNews = news => ({
  type: HOME_NEWS.SET,
  payload: news,
});

export { setHomeSpecialCars, setHomeCounters, setHomeNews };



// WEBPACK FOOTER //
// ./src/shared/actions/homeSpecialCars.js